<label class="form-label">{{ label }}</label>
<div class="row">
  <div class="col">
    <select class="form-select" [(ngModel)]="family" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()">
      @for (font of fonts; track font) {
        <option [ngValue]="font.value">{{ font.label }}</option>
      }
    </select>
  </div>
  <div class="col">
    <select class="form-select" [(ngModel)]="style" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()">
      @for (style of styles; track style) {
        <option [ngValue]="style.value">{{ style.label }}</option>
      }
    </select>
  </div>
  <div class="col-auto d-flex align-items-center">
    <img src="/images/misc/font-size.svg" alt="font size" height="24">
    <input class="ms-1 form-control form-width" [(ngModel)]="size" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()" (blur)="checkSize()"
      type="number" min="1"
      step="1">
    <span class="ms-1 fw-bold">px</span>
  </div>
  <div class="col-auto d-flex align-items-center">
    <img src="/images/misc/font-weight.svg" alt="font weight" height="24">
    <select class="ms-1 form-control form-width" [(ngModel)]="weight" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChange()" (blur)="checkWeight()">
      <option value="100">Thin (100)</option>
      <option value="200">Thin (200)</option>
      <option value="300">Thin (300)</option>
      <option value="400">Thinner (400)</option>
      <option value="500">Normal (500)</option>
      <option value="600">Bolder (600)</option>
      <option value="700">Bold (700)</option>
      <option value="800">Bold (800)</option>
      <option value="900">Bold (900)</option>
    </select>
  </div>
</div>
